/**
 * Punto de entrada para el módulo Kanban
 * Exporta el reducer combinado y todas las acciones
 */
import rootKanbanReducer from './rootKanbanReducer';

// Exportar todas las acciones
export * from './boardActions';
export * from './columnActions';
export * from './ticketActions';
export * from './commentActions';

// Exportar el reducer combinado como predeterminado
export default rootKanbanReducer;
